import React from "react";
import { createPortal } from "react-dom";
import { usePreviewFrame } from "./Hooks";
export default function PreviewComponent({
  narrow,
  children,
}: {
  narrow: boolean;
  children: React.ReactNode;
}) {
  const { body, initialize } = usePreviewFrame();
  return (
    <div
      className="cms-preview"
      style={{ width: narrow ? 390 : "100%", maxWidth: "100%" }}
    >
      <iframe
        ref={initialize}
        onLoad={(event) => initialize(event.currentTarget)}
        title={narrow ? "Mobile draft preview" : "Desktop draft preview"}
        style={{
          width: "100%",
          height: 800,
          border: "1px solid #c7bfaf",
          background: "#231f20",
        }}
      />
      {body &&
        createPortal(<div {...({ inert: "" } as any)}>{children}</div>, body)}
    </div>
  );
}
